import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import {useContext} from "react";
import ModalContext from "./envResultsTable/ModalContext";
import Succeed from "../../assets/createEnvAssets/Succeed";
import styled from "styled-components";
import FailedIcon from "../../assets/createEnvAssets/FailedIcon";
import CancelIcon from "../../assets/createEnvAssets/CancelIcon";
import {style} from "./BasicModal"

const CancelButtonWrapper = styled.div`
  display: flex;
  justify-content: end;

  .cancel_button {
    width: 10px;
    cursor: pointer;
  }
`;

const MessageContent = styled.p`
  padding: 10px;
  font-size: 13px;
`;

const Button = styled.button`

  width: 155px;
  background: var(--color-brand-pink-primary);
  color: white;
  border: 1px solid var(--color-createenv-form-btn-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 10px;
  display: inline;

  &:hover {
    background: #fa105b;
  }
`;

export const Line = styled.div`
  background-color: #c1b9b9;
  margin: 15px;
  padding: 0.5px;
`


export default function SalesForceFailedModal() {
    const {
        failedSalesForceModalIsOpen,
        setFailedSalesForceModalIsOpen,
        envUrl,
        contentMessage,
        setContentMessage
    } = useContext(ModalContext);
    const handleClose = () => {
        setFailedSalesForceModalIsOpen(false)
        setContentMessage("");
    }
    return (
        <div>
            <Modal
                open={failedSalesForceModalIsOpen}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className={"failed-salesforce-modal"}>
                    <CancelButtonWrapper>
                                <span className={"cancel_button"}
                                      onClick={() => setFailedSalesForceModalIsOpen(false)}>
                                    <CancelIcon/>
                                </span>
                    </CancelButtonWrapper>
                    <Succeed/>
                    <MessageContent  id={"first-message"}>{contentMessage[0]}</MessageContent>
                    {
                        envUrl === "" ?
                            <Button onClick={() => setFailedSalesForceModalIsOpen(false)}>Close</Button> :
                            <Button onClick={() => window.open(envUrl, "_blank")} id={"go_to_env_btn"}>Go to My
                                Environment</Button>
                    }
                    <Line/>
                    <FailedIcon/>
                    <MessageContent  id={"second-message"}>{contentMessage[1]}</MessageContent>
                </Box>
            </Modal>
        </div>
    );

}
